import React from 'react';
import DefaultPage from './DefaultPage';
import Follow from '../Follow';
import Highlights from '../Highlights';
import Whois from '../Whois';
import HeroSection from '../HeroSection';
import heroVideo from '../../videos/gym.mp4';


function Gym(props) {
    return (
        <DefaultPage
            sections={
                <>
                    <HeroSection
                        heroVideo={heroVideo}
                        body={
                            <>
                                <div className="row">
                                    <h1 data-aos="zoom-in" className="display-1">LEGENDS</h1>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <h1 data-aos="zoom-in" className="display-3">ARE BUILT AT THE</h1>
                                    </div>
                                </div>
                                <div className="row">
                                    <h1 data-aos="zoom-in" className="display-1 red-font">EASTSIDE</h1>
                                </div>
                                <div className="row">
                                    <h1 data-aos="zoom-in" className="display-1 red-font">MECCA</h1>
                                </div>
                            </>
                        }
                    />
                    <Whois></Whois>
                    <Highlights></Highlights>
                    <Follow></Follow>
                </>
            }
        />
    );
}

export default Gym;